ToolsTemplate from ../templates/tools
SampleToolTemplate from ../templates/sample-tool
ToolTemplate from ../templates/tool

Observable from @danielx/observable

export Tools := (editor) ->
  self :=
    toggleToolsOpen: ->
      if self.toolsClass() is "open"
        self.toolsClass("")
      else
        self.toolsClass("open")

    toolsClass: Observable ""

    additionalTools: ->
      {
        erase
        selection
        velocity
        duration
        pan
        timeSignature
        keySignature
        setTempo
      } := editor.tools

      freeTools := [erase, selection, velocity, duration, pan]
      let tools

      if editor.purchased()
        paidTools := [timeSignature, keySignature, setTempo]
        tools = freeTools.concat paidTools
      else
        tools = freeTools

      tools.map (tool) ->
        ToolTemplate
          class: tool.name
          click: ->
            editor.activeToolIndex tool.index
          active: ->
            "active" if editor.activeToolIndex() is tool.index
          title: tool.title

    instrumentTools: ->
      [0...16].map (c) ->
        SampleToolTemplate
          instrumentClass: ->
            i := editor.song.spriteForChannel(c)
            l := editor.spriteTextures().length
            if i?
              `i${i % l}`
            else
              "hidden"
          active: ->
            "active" if editor.activeChannel() is c and editor.activeToolIndex() is 0
          click: ->
            editor.activeChannel(c)
            editor.activeToolIndex(0)
            editor.playNote(c)
            setTimeout ->
              editor.releaseNote(c)
            , 500

    element: null

  self.element = ToolsTemplate self

  return self

export default Tools
